import { defineStore } from 'pinia'
import { useSiteConfigStore } from '@/stores/config/site'
import { useShoppingStore } from '@/stores/shopping'

export const useCartConfigStore = defineStore('cartConfig', {
  state: () => ({
    shoppingCartViewConfig: {},
    sideCartMenuConfig: {}
  }),
  getters: {
    getCartViewConfig: (state) => state.shoppingCartViewConfig,
    getSideCartMenuConfig: (state) => state.sideCartMenuConfig,
    getIsLogicCreditBalanceByUserActive: (state) =>
      state.sideCartMenuConfig?.logicCreditBalanceByUser || false,
    getRequiredProgressBarCredit: (state) =>
      state.sideCartMenuConfig?.logicCreditBalanceByUser &&
      state.sideCartMenuConfig?.progressBarRequiredCredit,
    getMessageCreditBalance: (state) => {
      const shoppingStore = useShoppingStore()
      const messageBase = state.sideCartMenuConfig?.messageCreditBalanceByUser || ''
      const totalToPay = shoppingStore.cartTotalPriceWithPricingRules - shoppingStore.getUserBalance

      if (!messageBase.includes('##price')) {
        console.warn('El mensaje base no contiene el marcador ##price.')
        return messageBase
      }

      return messageBase.replace('##price', `$${totalToPay}`)
    },
    getMinPurchasePriceMessage: (state) => {
      const siteConfigStore = useSiteConfigStore()
      const messageBase = state.shoppingCartViewConfig?.minPurchasePriceMessage || ''
      const minimumPurchasePrice = siteConfigStore.getMinimumPurchasePrice || 1500

      if (!messageBase.includes('##price')) {
        console.warn('El mensaje base no contiene el marcador ##price.')
        return messageBase
      }

      return messageBase.replace('##price', `$${minimumPurchasePrice}`)
    },
    getMinimumPurchaseMessageAcomplished: (state) => {
      const siteConfigStore = useSiteConfigStore()
      const messageBase = state.sideCartMenuConfig?.messageMinimumPurchasePriceAcomplished || ''
      const minimumPurchasePrice = siteConfigStore.getMinimumPurchasePrice || 1500

      if (!messageBase.includes('##price')) {
        console.warn('El mensaje base no contiene el marcador ##price.')
        return messageBase
      }

      return messageBase.replace('##price', `$${minimumPurchasePrice}`)
    }
  },
  actions: {
    setCartConfig({ view, sideMenu }) {
      this.shoppingCartViewConfig = view || {}
      this.sideCartMenuConfig = sideMenu || {}
    }
  },
  persist: true
})
